import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCryptoUsdt = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1.125em",
	height: "1.125em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 20,
		cy: 20,
		r: 20,
		fill: "#50AF95"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M22.5308 22.2674C22.3894 22.278 21.6587 22.3216 20.0289 22.3216C18.7325 22.3216 17.8121 22.2827 17.4892 22.2674C12.4795 22.047 8.74017 21.1749 8.74017 20.1308C8.74017 19.0867 12.4795 18.2158 17.4892 17.9919V21.3989C17.8169 21.4224 18.7549 21.4778 20.0513 21.4778C21.6069 21.4778 22.3858 21.413 22.5261 21.4V17.9942C27.5252 18.217 31.2563 19.089 31.2563 20.1308C31.2563 21.1726 27.5264 22.0447 22.5261 22.2662L22.5308 22.2674ZM22.5308 17.6419V14.5931H29.5074V9.944H10.5126V14.5931H17.4881V17.6407C11.8184 17.9011 7.55463 19.0242 7.55463 20.3701C7.55463 21.7159 11.8184 22.8378 17.4881 23.0994V32.8691H22.5296V23.0959C28.1863 22.8354 32.443 21.7135 32.443 20.3689C32.443 19.0242 28.1899 17.9023 22.5296 17.6407L22.5308 17.6419Z",
		fill: "white"
	})]
});
export default SvgCryptoUsdt;
